module.exports = __webpack_public_path__ + "static/media/winter_super_pack_dog_bed_FR.db3f5b79.png";